import {CheckBox, CheckBoxOutlineBlank, IndeterminateCheckBox} from '@mui/icons-material'
import clsx from 'clsx'
import React from 'react'







const Checkbox = (props) => {
  const {active, className, disabled, onClick} = props
  const Icon = active ? CheckBox : active === false ? CheckBoxOutlineBlank : IndeterminateCheckBox
  const cursor = disabled ? 'cursor-not-allowed' : 'cursor-pointer'
  const opacity = disabled ? 'opacity-[.38]' : 'opacity-100'

  return (
    React.createElement('div', {
      className: clsx(
        'text-slate-600',
        'h-6',
        'w-6',
        'block',
        'select-none',
        cursor,
        opacity,
        className
      ),
      onClick: disabled ? undefined : onClick,}

      , React.createElement(Icon, null )
    )
  )
}

export default Checkbox
